import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=67917a73&scoped=true"
import script from "./Figure.vue?vue&type=script&lang=js"
export * from "./Figure.vue?vue&type=script&lang=js"
import style0 from "./Figure.vue?vue&type=style&index=0&id=67917a73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67917a73",
  null
  
)

export default component.exports